module.exports = __webpack_public_path__ + "static/media/eve.f35236a6.svg";